import fetch from 'utils/fetch';
import { List } from 'immutable';
import { decrementMessagingCounter } from 'plugins/navbar';

export const REQUEST_MESSAGES = 'REQUEST_MESSAGES';
export const RECEIVE_MESSAGES = 'RECEIVE_MESSAGES';
export const REQUEST_READ_MESSAGES = 'REQUEST_READ_MESSAGES';
export const MESSAGES_READ = 'MESSAGES_READ';
export const MESSAGES_READ_ERROR = 'MESSAGES_READ_ERROR';
export const CHANGE_SCROLL_POSITION = 'CHANGE_SCROLL_POSITION';

function requestMessages(user) {
  return {
    type: REQUEST_MESSAGES,
    payload: {
      user,
    },
  };
}

function receiveMessages(user, messages, total) {
  return {
    type: RECEIVE_MESSAGES,
    payload: {
      user,
      messages,
      total,
    },
  };
}

function requestReadMessages(user) {
  return {
    type: REQUEST_READ_MESSAGES,
    payload: {
      user,
    },
  };
}

function messagesRead(user) {
  return {
    type: MESSAGES_READ,
    payload: {
      user,
    },
  };
}

function messagesReadError(user, error) {
  return {
    type: MESSAGES_READ_ERROR,
    payload: {
      user,
      error,
    },
  };
}

function shouldFetchMessages(state, user) {
  const { messages, total } = state.messaging.mailbox;

  return !total || messages.size < total;
}

function getEndingIndex(state, user) {
  const { messages } = state.messaging.mailbox;
  return List(messages)
    .map(m => m.index)
    .min(m => m);
}

export function fetchMessages(user) {
  return (dispatch, getState) => {
    const state = getState();

    if (shouldFetchMessages(state, user)) {
      const endingIndex = getEndingIndex(state, user);
      const url = endingIndex
        ? `/messaging/${user}/messages.json?ending_before=${endingIndex}`
        : `/messaging/${user}/messages.json`;

      dispatch(requestMessages(user));
      return fetch(url)
        .then(r => r.json())
        .then(result => {
          const { messages, total } = result;
          dispatch(receiveMessages(user, messages, total));
        });
    }
  };
}

function getUnreadCount(state, user) {
  if (state.messaging.mailbox.isReading) {
    return 0;
  }

  const message = state.messaging.threads.messages.get(user.toString());
  return message ? message.index - message.lastReadIndex : 0;
}

export function readMessages(user) {
  return (dispatch, getState) => {
    const state = getState();

    const unreadCount = getUnreadCount(state, user);
    if (unreadCount > 0) {
      dispatch(requestReadMessages(user));
      return fetch(`/messaging/${user}/read`, {
        method: 'PUT',
      })
        .then(() => {
          decrementMessagingCounter(unreadCount);
          return dispatch(messagesRead(user));
        })
        .catch(error => dispatch(messagesReadError(user, error)));
    }
  };
}

export function changeScrollPosition(user, position) {
  return {
    type: CHANGE_SCROLL_POSITION,
    payload: {
      user,
      position,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/messaging/actions/mailbox.js